export default __webpack_public_path__ + "static/media/EBU_bg.04680976.png";